import * as React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  ButtonGroup,
} from '@material-ui/core'
import { useTranslation } from 'i18n'

const useStyles = makeStyles({
  paper: {
    borderRadius: 15,
  },
  actions: {
    padding: 0,
  },
  buttonGroup: {
    borderRadius: 0,
    padding: 10,
    fontWeight: 600,
  },
  title: {
    margin: '0 auto',
    fontWeight: 600,
    padding: 25,
  },
})

const Component = ({ title, open, onClose, onSubmit, ...props }) => {
  const { t } = useTranslation('components')
  const classes = useStyles({})

  return (
    <Dialog
      classes={{
        paper: classes.paper,
      }}
      open={open}
      color="rgba(252, 252, 252, 0.8)"
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...props}
    >
      <DialogTitle
        disableTypography
        classes={{ root: classes.title }}
        id="alert-dialog-title"
      >
        {title}
      </DialogTitle>
      <DialogActions className={classes.actions}>
        <ButtonGroup
          fullWidth
          variant="outlined"
          color="default"
          classes={{ grouped: classes.buttonGroup }}
        >
          <Button onClick={onClose}>{t('Dialog.Confirm.cancel')}</Button>
          <Button onClick={onSubmit}>OK</Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  )
}

export default Component
